import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
// VITE_FIREBASE_API_KEY=AIzaSyBb_9IO142S5YK3VSOEfqrAQoOaawk9c78
// VITE_FIREBASE_AUTH_DOMAIN=dev-daton-37754.firebaseapp.com
// VITE_FIREBASE_PROJECT_ID=dev-daton-37754
// VITE_FIREBASE_STORAGE_BUCKET=dev-daton-37754.appspot.com
// VITE_FIREBASE_MESSAGING_SENDER_ID=781276801014
// VITE_FIREBASE_APP_ID=1:781276801014:web:e8bd6588c1177f3a7849d7
// VITE_FIREBASE_MEASUREMENT_ID=G-94WZ8Z1GZ8

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default app;
